export const aidResultsBuildReducer = (state, action) => {
  switch (action.type) {
    case "build_found":
      return {
        ...state,
        [action.modelId]: { status: "building", error: null },
      };
    case "build_complete":
      return {
        ...state,
        [action.modelId]: { status: "complete", error: action.error },
      };
    default:
      return state;
  }
};
